// Synced from python definitions common/exceptions.py
export const UserFacingErrorType = {
  UNKNOWN: "UNKNOWN",
  ALREADY_EXISTS: "ALREADY_EXISTS",
  BAD_ANSWER_LOCATION: "BAD_ANSWER_LOCATION",
  CANCELLED: "CANCELLED",
  CONVERSATION_TOO_LONG: "CONVERSATION_TOO_LONG",
  EXTERNAL_PERMISSION_DENIED: "EXTERNAL_PERMISSION_DENIED",
  INVALID_ARGUMENT: "INVALID_ARGUMENT",
  INVALID_DOCUMENT: "INVALID_DOCUMENT",
  INVALID_STATE_FOR_ACTION: "INVALID_STATE_FOR_ACTION",
  MISSING_FIELD: "MISSING_FIELD",
  NOT_FOUND: "NOT_FOUND",
  NOT_YET_IMPLEMENTED: "NOT_YET_IMPLEMENTED",
  NO_QUESTIONS_FOUND: "NO_QUESTIONS_FOUND",
  NO_SLACKBOT_CONFIGURATION_FOUND: "NO_SLACKBOT_CONFIGURATION_FOUND",
  NO_TEXT_FOUND: "NO_TEXT_FOUND",
  NOT_READY: "NOT_READY",
  OUT_OF_DATE: "OUT_OF_DATE",
  PERMISSION_DENIED: "PERMISSION_DENIED",
  UNAUTHORIZED: "UNAUTHORIZED",
  UNKNOWN_SHEET_LAYOUT: "UNKNOWN_SHEET_LAYOUT",
  UNSPECIFIED: "UNSPECIFIED",
  UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE",
  USER_DISABLED: "USER_DISABLED",
  USER_HAS_NO_DOCUMENTS: "USER_HAS_NO_DOCUMENTS",
}

export type UserFacingErrorType = keyof typeof UserFacingErrorType
